import { Trans } from 'react-i18next';
import VideoPoster from '../../assets/1afcc6b4f2baae5b.jpg';
import Video from '../../assets/1afcc6b4f2baae5b.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const DataCenterSection1 = () => {
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const viewheight = useVisualViewportHeight();
  const { isMobile, isPad } = useDeviceType();
  const { trackVideoPlay } = useAnalytics();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{
      background: '#1a2f7e',
      ...(isMobile && !isPad ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          onPlay={() => trackVideoPlay('데이터센터', 'data_center', 0)}
          style={{
            width: '100%',
            height: isMobile && !isPad ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1 style={{
          color: 'white',
          position: 'absolute',
          bottom: (isMobile && !isPad) ? isEng ? '224px' : isChina ? '141px' : '170px' : `${topSectionBottom}px`,
          left: `${padding}px`,
          width: isMobile ? '90%' : '50%',
          transform: isPad ? 'scale(0.80)' : 'scale(1)',
          transformOrigin: 'left bottom',
        }}>Data Center<br />Utility Engineering</SubH1>
        <H10
          style={{
            width: isMobile && !isPad ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile && !isPad ? '0px' : `${topSectionBottom}px`,
            left: isMobile && !isPad ? `${padding}px` : undefined,
            right: isMobile && !isPad ? undefined : `${padding}px`,
            transform: isPad ? 'scale(0.85)' : 'scale(1)',
            transformOrigin: 'right bottom',
            ...(isMobile && !isPad
              && { height: isEng ? '212px' : isChina ? `124px` : `146px` }),
            ...isChina ? {wordBreak: 'break-word'} : {}
          }}
        >
          <Trans i18nKey='비비테크는 반도체 Hook-up 분야에서 축적한 정밀 배관 기술을 바탕으로, AI 서버 등 고발열 IT 인프라에 최적화된 고효율 냉각 솔루션을 제공합니다. 주요분야는 냉각수용 PCW 배관 Spool과 Manifold를 설계, 제작하여 공급합니다.'/>
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default DataCenterSection1;
